import axios from "axios";

export default {
  getReports(params) {
    return axios.post("/sp/Reports/GetReports", params);
  },
  deleteReport(params) {
    return axios.delete("/sp/Reports/DeleteReport", { params });
  },
  downloadReportFile(params) {
    return axios.get("/sp/Reports/DownloadReport", { params });
  },
  uploadReportFile(id, payload) {
    return axios.put("/sp/Reports/UpdateReport", payload, { params: { id } });
  },
};
